import axios from '../axios'

/**
 * 查询
 */
export const findPage = data => {
    return axios({
        url: '/paylog/list',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/modules/paylog.js